export const GET_All_ONLINE_TEST= "GET_All_ONLINE_TEST";
export const GET_SINGLE_ONLINE_TEST= "GET_SINGLE_ONLINE_TEST";
export const SHOW_SINGLE_ONLINE_TEST_ANSWER= "SHOW_SINGLE_ONLINE_TEST_ANSWER";
export const GET_All_TEST_SCORE= "GET_All_TEST_SCORE";
